import React, { useState } from "react";
import { Button, Input, Modal, Select } from "antd";
import { Upload } from "antd";
import defaultProfileImage from "../../assets/default_profile_img.png";
import uploadProfileCameraIcon from "../../assets/upload_profile_camera_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfileDetailsAPI } from "../../redux/actions/ChatWithData/ChatWithDataApi";
import { countriesList } from "../../redux/constants";
import { setUserProfileModalFlag } from "../../redux/actions/ChatWithData/ChatWithData";

const { Option } = Select;

const ProfileModal = ({ userProfileModalFlag }) => {
  const dispatch = useDispatch();
  const userProfileDetails = useSelector(
    (state) => state?.ChatWithData?.user_profile_details
  );
  const userProfileSaveLoader = useSelector(
    (state) => state?.ChatWithData?.user_profile_save_loader
  );
  let p_token = localStorage.getItem("p_token");

  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState(
    userProfileDetails?.profile_info?.profile_pic
      ? [{ thumbUrl: userProfileDetails?.profile_info?.profile_pic }]
      : []
  );
  const [firstName, setFirstName] = useState(
    userProfileDetails?.profile_info?.first_name
      ? userProfileDetails?.profile_info?.first_name
      : null
  );
  const [lastName, setLastName] = useState(
    userProfileDetails?.profile_info?.last_name
      ? userProfileDetails?.profile_info?.last_name
      : null
  );
  const [emailName, setEmailName] = useState(
    userProfileDetails?.profile_info?.email
      ? userProfileDetails?.profile_info?.email
      : null
  );
  const [countryCode, setCountryCode] = useState(
    userProfileDetails?.profile_info?.country_code
      ? userProfileDetails?.profile_info?.country_code
      : "+91"
  );
  const [mobileNumber, setMobileNumber] = useState(
    userProfileDetails?.profile_info?.mobile_number
      ? userProfileDetails?.profile_info?.mobile_number
      : null
  );
  const [mobileNumberError, setMobileNumberError] = useState(null);

  const handleUploadProfileImage = ({ fileList: newFileList }) => {
    let updatedList = newFileList;
    if (updatedList?.[0]?.response && updatedList?.[0]?.error?.message) {
      updatedList[0].response = "";
      updatedList[0].error.message = "Profile Image";
    }

    setFileList(updatedList);
  };
  const onPreview = async (file) => {
    let src = file?.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file?.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const selectBefore = (
    <Select
      showSearch
      defaultValue={countryCode}
      style={{
        width: 100,
      }}
      onChange={(e) => setCountryCode(e)}
    >
      {countriesList?.map((country, index) => {
        return (
          <Option
            className="mobile_number_input-country-flag"
            key={index}
            value={country?.dialCode}
          >
            <img src={country?.flag} className="profile-country-code-img" />{" "}
            {country?.dialCode}
          </Option>
        );
      })}
    </Select>
  );

  const handleMobileNumber = (value) => {
    if (value?.length === 0 || value?.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handlSaveProfileDetails = () => {
    if (
      mobileNumber === null ||
      mobileNumber?.length === 0 ||
      mobileNumber?.length === 10
    ) {
      let obj = {
        p_token: p_token,
        first_name: firstName,
        last_name: lastName,
        country_code: countryCode,
        mobile_number: mobileNumber,
        profile_pic: fileList?.[0]?.thumbUrl,
      };

      dispatch(updateUserProfileDetailsAPI(obj));
      setMobileNumberError(null);
    } else {
      setMobileNumberError("Not enough digits for a mobile number.");
    }
  };

  const handleCloseModal = () => {
    dispatch(setUserProfileModalFlag(false));

    setFileList([]);
    setFirstName(null);
    setLastName(null);
    setEmailName(null);
    setCountryCode("+91");
    setMobileNumber(null);
  };

  return (
    <>
      <Modal
        open={userProfileModalFlag}
        // title=""
        onOk={handlSaveProfileDetails}
        onCancel={handleCloseModal}
        footer={[
          <Button className="modal_cancel_btn" onClick={handleCloseModal}>
            Cancel
          </Button>,
          <Button
            className="modal_save_btn"
            loading={userProfileSaveLoader ? true : false}
            onClick={handlSaveProfileDetails}
          >
            Save
          </Button>,
        ]}
        closable={false}
      >
        <h4 className="profile_heading_text">My Profile</h4>

        {/* Upload Profile */}
        <Upload
          beforeUpload={() => {
            return false;
          }}
          listType="picture-card"
          fileList={fileList}
          onChange={handleUploadProfileImage}
          onPreview={onPreview}
          accept=".png,.jpg,.jpeg,.svg"
          showUploadList={{
            showPreviewIcon: false,
          }}
        >
          {fileList.length < 1 && (
            <>
              Add Profile
              {/* <img
                src={defaultProfileImage}
                className="upload-profile-default-img"
              /> */}
              {/* <img
                src={uploadProfileCameraIcon}
                className="upload-profile-camera-img"
              /> */}
            </>
          )}
        </Upload>

        {/* Deatils */}
        {/* <p className="profile_sub_heading_text">Your Information</p> */}
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Input
            className="first_name_input"
            placeholder="First Name"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e?.target?.value)}
          />
          <Input
            className="last_name_input"
            placeholder="Last Name"
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e?.target?.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Input
            disabled
            className="email_name_input"
            placeholder="Email"
            type="email"
            value={emailName}
            onChange={(e) => setEmailName(e?.target?.value)}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Input
            className="mobile_number_input"
            addonBefore={selectBefore}
            placeholder="Mobile No"
            value={mobileNumber}
            type="number"
            onChange={(e) => handleMobileNumber(e?.target?.value)}
          />
        </div>
        {mobileNumberError ? (
          <p style={{ color: "red", marginLeft: "5px" }}>
            {mobileNumberError ? mobileNumberError : ""}
          </p>
        ) : (
          ""
        )}
      </Modal>
    </>
  );
};

export default ProfileModal;
